(()=>{'use strict';const $=s=>document.querySelector(s),cfg=JSON.parse($('#acp-config').textContent),product=$('#acp-product')?JSON.parse($('#acp-product').textContent):null,drawer=$('#acp-drawer'),modal=$('#acp-gallery-modal'),sticky=$('.acp-sticky'),form=$('#acp-form');let busy=false,cart=null,passed=false,protectionUnitPrice=null,referenceProduct=product?.handle===cfg.handle?product:null;const money=n=>new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:cart?.currency||product?.currency||'USD'}).format(n/100),esc=s=>String(s??'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));const root=cfg.root.endsWith('/')?cfg.root:cfg.root+'/';
















const coverageVariant=46987114840111,legacyCoverageVariant=46989948977199;
const isCoverage=i=>[coverageVariant,legacyCoverageVariant].includes(i.variant_id);
const coverageQuantity=data=>data.items.filter(i=>['aera-ergonomic-orthopedic-cushion-pro','aera-ergonomic-seat-cushion'].includes(i.handle)).reduce((n,i)=>n+i.quantity,0);
async function syncCoverage(data,call){const count=coverageQuantity(data),services=data.items.filter(isCoverage);if(!services.length)return data;const primary=services.find(i=>i.variant_id===coverageVariant),updates={};services.forEach(i=>{const next=count&&i===primary?count:0;if(i.quantity!==next)updates[i.key]=next;});if(Object.keys(updates).length)data=await call('/cart/update.js',{updates});if(count&&!primary){await call('/cart/add.js',{items:[{id:coverageVariant,quantity:count,properties:{_acp_protection:'true'}}]});data=await call('/cart.js');}return data;}
const cartTitle=i=>i.handle==='aera-ergonomic-orthopedic-cushion-pro'?'Orthopedic Cushion Pro':i.handle==='aera-ergonomic-seat-cushion'?'Lumbar Support Seat Cushion':i.product_title;

async function api(path,data){const r=await fetch(root+path,{method:data?'POST':'GET',headers:{'Content-Type':'application/json'},body:data?JSON.stringify(data):undefined});const d=await r.json();if(!r.ok)throw Error(d.description||d.message||'Unable to update your bag. Please try again.');return d;}















function syncSticky(){if(sticky)sticky.hidden=!product||!passed||!!document.querySelector('dialog[open]');}















document.querySelectorAll('dialog').forEach(d=>{d.addEventListener('close',()=>{document.body.style.overflow='';syncSticky()});d.addEventListener('click',e=>{if(e.target===d){const r=d.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)d.close();}});d.querySelectorAll('[data-acp-close]').forEach(b=>b.onclick=()=>d.close());});















function open(d){d.showModal();document.body.style.overflow='hidden';syncSticky();}















function regularUnit(i){return i.handle===cfg.handle?Math.max(i.original_price,referenceProduct?.variants.find(v=>v.id===i.variant_id)?.compare_at_price||0):i.original_price;}

function render(){document.querySelectorAll('[data-acp-count]').forEach(n=>n.textContent=cart.items.filter(i=>!isCoverage(i)).reduce((n,i)=>n+i.quantity,0));const cushions=cart.items.filter(i=>i.handle===cfg.handle),services=cart.items.filter(isCoverage),items=cart.items.filter(i=>!isCoverage(i));$('#acp-cart-body').innerHTML=items.map(i=>`<article class="acp-line"><img src="${esc(i.image||'')}" alt="${esc(i.product_title)}" width="64" height="64"><div class="acp-line-details"><h3>${esc(cartTitle(i))}</h3>${i.variant_title&&i.variant_title!=='Default Title'?`<p class="acp-line-variant">${esc(i.variant_title)}</p>`:''}<div class="acp-unit-price">${regularUnit(i)>i.final_price?`<s>${money(regularUnit(i))}</s>`:''}<strong>${money(i.final_price)}</strong>${i.line_level_discount_allocations.map(d=>`<span class="acp-discount-badge">◆ ${esc(d.discount_application.title)}</span>`).join('')}</div><div class="acp-line-bottom"><div class="acp-line-controls"><button data-key="${esc(i.key)}" data-qty="${i.quantity-1}" aria-label="Decrease quantity">−</button><span>${i.quantity}</span><button data-key="${esc(i.key)}" data-qty="${i.quantity+1}" aria-label="Increase quantity">+</button></div><div class="acp-line-total">${regularUnit(i)*i.quantity>i.final_line_price?`<s>${money(regularUnit(i)*i.quantity)}</s>`:''}<strong>${money(i.final_line_price)}</strong>${regularUnit(i)*i.quantity>i.final_line_price?`<small>You saved ${money(regularUnit(i)*i.quantity-i.final_line_price)}</small>`:''}</div></div><p class="acp-cart-guarantee">${['aera-bronoir-skin-pro-with-copper','aera-bronoir-complete-offer','aera-bronoir-skinpro-insoles','aera-bronoir-mystery-gift'].includes(i.handle)?'30-day return terms · <a href="/pages/aera-bronoir-returns">Offer exclusions apply</a>':i.handle==='aera-relivex-adaptive-correction-system'?'90-day return window · <a href="/pages/aera-relivex-return-policy">Terms</a>':i.handle===cfg.handle?'60-day coverage · <a href="/pages/acp-return-policy">Terms</a>':(/microinfusion|collagen-peptide|vitelia|zooone/.test(i.handle)?90:/arbutin/.test(i.handle)?60:30)+'-Day Money-Back Guarantee'}</p></div><button class="acp-line-remove" data-key="${esc(i.key)}" data-qty="0" aria-label="Remove ${esc(i.product_title)}"><svg width="13" height="16" viewBox="0 0 16 20" fill="none" aria-hidden="true"><path d="M2 5h12M6 2h4M4 5l1 13h6l1-13M7 8v7M9 8v7" stroke="currentColor" stroke-width="1.3"/></svg></button></article>`).join('')||'<p class="acp-cart-empty">Your cart is empty.</p>';$('#acp-total').textContent=money(cart.total_price);$('#acp-checkout').textContent='Check out • '+money(cart.total_price);$('#acp-checkout').hidden=!cart.item_count;$('#acp-protection-option').hidden=!coverageQuantity(cart)||!cfg.protection;$('.acp-protection-terms').hidden=!coverageQuantity(cart)||!cfg.protection;$('#acp-protection').checked=services.length>0;const protectedQuantity=coverageQuantity(cart);if(protectionUnitPrice!==null){$('[data-acp-protection-price]').textContent=money(protectionUnitPrice);$('.acp-protection-terms').textContent=money(protectionUnitPrice)+' × '+protectedQuantity+' cushions = '+money(services.length?services.reduce((sum,i)=>sum+i.final_line_price,0):protectionUnitPrice*protectedQuantity)+' '+(services.length?'selected':'if selected')+' · Terms';}const subtotal=cushions.reduce((sum,i)=>sum+i.final_line_price,0),mixed=items.some(i=>i.handle!==cfg.handle);$('#acp-cart-shipping').textContent=cushions.length?(subtotal>=4000?(mixed?'Your Cushion Pro gets FREE Shipping! 🎉':'Congrats! You get FREE Shipping! 🎉'):'Add '+money(4000-subtotal)+' for free Cushion Pro shipping.'):'Shipping calculated at checkout.';$('#acp-shipping-fill').style.width=Math.min(100,subtotal/4000*100)+'%';$('.acp-cart-progress').hidden=!cushions.length;let note=$('#acp-mixed-shipping');if(!note){note=document.createElement('p');note.id='acp-mixed-shipping';$('.acp-cart-progress').append(note);}note.textContent=mixed?'Other product shipping is calculated at checkout.':'';const savings=Math.max(0,cart.total_discount??(cart.items.reduce((sum,i)=>sum+i.original_price*i.quantity,0)-cart.total_price));$('.acp-cart-savings').hidden=!savings;$('.acp-cart-savings').title='Discounts applied to this cart';$('.acp-cart-savings small').textContent='discounts applied';$('#acp-savings').textContent='−'+money(savings);let flash=$('#acp-cart-flash');if(!flash){flash=document.createElement('p');flash.id='acp-cart-flash';$('#acp-cart-body').append(flash);}flash.hidden=!cushions.length||!cfg.saleEnd||Date.now()>=Date.parse(cfg.saleEnd);flash.textContent='🔥 Limited-time FLASH Deal';$('#acp-cart-body').querySelectorAll('[data-key]').forEach(b=>b.onclick=()=>run(async()=>{cart=await api('cart/change.js',{id:b.dataset.key,quantity:Number(b.dataset.qty)});await reconcile();}));}







async function reconcile(){if(!referenceProduct&&cart.items.some(i=>i.handle===cfg.handle)){try{referenceProduct=await api('products/'+cfg.handle+'.js');}catch(e){/* Actual cart totals remain usable if reference pricing is unavailable. */}}cart=await syncCoverage(cart,(url,body)=>api(url.slice(1),body));render();}



async function run(fn){if(busy)return;busy=true;document.querySelectorAll('#acp-form button,[data-acp-sticky-add],#acp-drawer button,#acp-protection').forEach(b=>b.disabled=true);$('#acp-cart-error').textContent='';if($('.acp-error'))$('.acp-error').textContent='';$('#acp-checkout').style.pointerEvents='none';try{await fn();}catch(e){$('#acp-cart-error').textContent=e.message;if(form)form.querySelector('.acp-error').textContent=e.message;}finally{busy=false;document.querySelectorAll('#acp-form button,[data-acp-sticky-add],#acp-drawer button,#acp-protection').forEach(b=>b.disabled=false);$('#acp-checkout').style.pointerEvents='';}}















document.querySelectorAll('[data-acp-bag]').forEach(b=>b.onclick=()=>run(async()=>{cart=await api('cart.js');await reconcile();open(drawer);}));















$('#acp-checkout').addEventListener('click',e=>{e.preventDefault();run(async()=>{cart=await api('cart.js');await reconcile();if(cart.item_count)location.assign(root+'checkout');});});



$('#acp-protection').onchange=e=>{const enabled=e.target.checked;run(async()=>{if(enabled&&!cart.items.some(isCoverage))await api('cart/add.js',{items:[{id:cfg.protection,quantity:coverageQuantity(cart),properties:{_acp_protection:'true'}}]});else if(!enabled){const updates={};cart.items.filter(isCoverage).forEach(i=>updates[i.key]=0);await api('cart/update.js',{updates});}cart=await api('cart.js');await reconcile();});};















if(cfg.protection)api('variants/'+cfg.protection+'.js').then(v=>{protectionUnitPrice=v.price;$('[data-acp-protection-price]').textContent=money(v.price);if(cart)render();}).catch(()=>{$('#acp-protection-option').hidden=true;});















if(product&&form){const variant=product.variants[0];$('[data-acp-sticky-img]').src=product.images[0];$('[data-acp-sticky-price]').textContent=money(variant.price);form.addEventListener('submit',e=>{e.preventDefault();if(!form.reportValidity())return;run(async()=>{await api('cart/add.js',{items:[{id:variant.id,quantity:Number($('#acp-qty').value)}]});cart=await api('cart.js');await reconcile();open(drawer);});});$('[data-acp-sticky-add]').onclick=()=>form.requestSubmit();new IntersectionObserver(entries=>{passed=entries[0].boundingClientRect.bottom<0;syncSticky();},{threshold:0}).observe($('#acp-atc'));document.querySelectorAll('[data-acp-image]').forEach(b=>b.onclick=()=>{$('#acp-hero').src=b.dataset.acpImage;document.querySelectorAll('[data-acp-image]').forEach(x=>x.setAttribute('aria-pressed',String(x===b)));});$('[data-acp-zoom]').onclick=()=>{modal.querySelector('img').src=$('#acp-hero').src;open(modal);};}















document.querySelectorAll('video').forEach(v=>{v.controls=true;v.removeAttribute('autoplay');});const track=$('#acp-tracking');if(track)track.onsubmit=e=>{e.preventDefault();const id=$('#acp-tracking-number').value.trim();if(id)window.open('https://t.17track.net/en#nums='+encodeURIComponent(id),'_blank','noopener');};})();















